import some from 'lodash/some';
import * as Sentry from '@sentry/vue';
import Vue from 'vue';
import { PENDO_INTERNAL_SUB_ID } from '@/settings/subscription-settings/utils';

export function isEventFromLocalhost (event = {}) {
    const url = event?.request?.url;

    return typeof url === 'string' && (url.includes('local.pendo.io') || url.includes('localhost'));
}

export function isEventFromVue (event = {}) {
    return some(
        event?.exception?.values,
        ({ mechanism, type }) => type === 'CustomEvent' && mechanism?.type === 'onerror',
    );
}

export function beforeSendSentryEvent (event, hint) {
    setTimeout(() => console.error(hint?.originalException || hint?.syntheticException || 'Unknown error'), 0);

    if (isEventFromLocalhost(event)) return null;

    // Sentry listens for 'error' events on the window but its handler expects an Error object,
    // not the CustomEvent we wrap Vue component errors in. Sentry reporting is handled when
    // creating the CustomEvent so we need to drop it before sending to prevent double reporting.
    //
    // @see vue-app#applySharedConfigToVueApp
    if (isEventFromVue(event)) return null;

    return event;
}

export function initSentryByActiveSub (store, router) {
    if (store.state.subscription?.active?.id) {
        return initializeSentry();
    }

    const unwatch = store.watch(
        () => store.getters['subscription/getActiveSub'],
        () => {
            initializeSentry(store, router);
            unwatch();
        },
    );
}

export function initializeSentry (store, router) {
    if (process.env.VUE_APP_ENV_IS_PROD !== 'true') return;

    const allowPerformanceLogging = store.state.subscription?.active?.id === PENDO_INTERNAL_SUB_ID;
    const releaseVersion = __PROCESS__.PENDO_RELEASE;

    try {
        Sentry.init({
            Vue,
            release: `engage-ui@${releaseVersion}`,
            // eslint-disable-next-line internal-rules/no-email-addresses
            dsn: 'https://3599373947c84bd49c23de5b7f838908@o69161.ingest.sentry.io/4504399166046208',
            integrations: [Sentry.browserTracingIntegration({ router })],
            attachStacktrace: true,
            environment: __PROCESS__.PENDO_ENV,
            sampleRate: 1,
            tracesSampleRate: allowPerformanceLogging ? 1 : 0,
            beforeSend: beforeSendSentryEvent,
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    }
}
